module.exports = __webpack_public_path__ + "media/images/e-kvitok/toggle_destinations-9909679c5724448189befccbcf73237e.svg";